<template>
  <v-dialog v-model="dialog" max-width="450">
      <template #activator="{on}">
          <v-btn v-on="on" :disabled="loading" outlined>Add new location for this product</v-btn>
      </template>
      <v-card>
            <v-card-title>Add new location for this product</v-card-title>
            <v-card-text>
                <v-form ref="addLocation">
                    <v-container>
                        <v-row>
                            <v-col md="12">
                                <warehouse-location v-model="location" :warehouseId="warehouse" @locationSelected="locationSelected=$event" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col md="12">
                                <v-text-field label="Quantity" type="number" :min="0" :max="remain" step="1" :rules="[maximum, isInteger, greaterThanZero]" v-model="quantity" :hint="'Remain '+remain+' to dispatch'"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn color="primary" outlined @click="close">Cancel</v-btn>
                <v-spacer />
                <v-btn color="success" @click="addLocation">Add</v-btn>
            </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import WarehouseLocation from '../forms/autocomplete/WarehouseLocation.vue';
export default {
  components: { WarehouseLocation },
    data: () => ({
        location: '',
        quantity: 0,
        dialog: false,
        locationSelected: null,
    }),
    props:{
        warehouse:{
            type: Number,
            required: true
        },
        remain:{
            type:Number,
            default:0
        },
        loading:{
            type:Boolean,
            default:false
        }
    },
    methods: {
        maximum(value){
            return value <= this.remain || 'Maximum '+this.remain;
        },
        isInteger(value){
            return value - parseInt(value) == 0 || 'Only integer';
        },
        greaterThanZero(value){
            return value > 0 || 'Must be greater than zero';
        },
        addLocation() {
            if(this.$refs.addLocation.validate()){
                this.$emit('add-location', {
                    id:this.location,
                    location: this.locationSelected.location,
                    currentStock:0,
                    quantity: this.quantity
                });
                
                this.close()
            }
        },
        close() {
            this.location = '';
            this.locationSelected = null;
            this.quantity = 0;
            this.dialog = false;
        }
    }
}
</script>

<style>

</style>